module.exports = __webpack_public_path__ + "media/img/vca/sponsors/human-6bd0708d0bf050a262f108bd3c906e97.png";